import { Grid } from '@mui/material'
import { observer } from 'mobx-react-lite'
import React from 'react'
import { IProjectFormPackage } from '../../interfaces/projects/IProjects'
import { ITableForm } from '../OPcomponents/OPNewTable'
import '../Profile/myskills.scss'
import '../Profile/profile.scss'
import ProjectHeader from '../Profile/workhistory/ProjectHeader'
import '../styles/grid.scss'
import ProjectMembers from './ProjectMembers'

const ProjectInfo = (props: ITableForm): JSX.Element => {
  const projectData = props.data as IProjectFormPackage

  return (
    <Grid container rowSpacing={4}>
      <Grid item xs={8}>
        <ProjectHeader data={projectData?.project} />
      </Grid>
      <Grid item xs={4}>
        <ProjectMembers data={projectData?.projectUsers} />
      </Grid>
    </Grid>
  )
}

export default observer(ProjectInfo)
